<template>
  <layout-checkout>
    <template slot="body">
      <a href="#" @click="backToCart($event)">
        <icon-base width="1em" height="1em">
          <icon-angle-left />
        </icon-base> Back to cart
      </a>
      <h3>Select Payment Method</h3>

      <div class="posabit-info-banner">
        <b>Contactless payments are now available via POSaBIT ACH!</b><br/>
        If you would like to use ACH as your form of payment for this order, and future orders, select 'Pay with POSaBIT ACH', then click the login button below to connect your bank account.
      </div>

      <form class="PaB-checkout-form" ref="checkoutForm" @submit="setPayment($event)">
        <p class="PaB-ach-text">
          <input v-model="pay_type" type="radio" name="pay_type" id="payment_posabit" value="posabit">
          <label for="payment_posabit"> Pay with POSaBIT ACH</label> &nbsp;<span v-if="achEnabled" style="color: #8ac440"><icon-base width="1em" height="1em" viewBox="0 0 25 25"><icon-link /></icon-base> Bank Account Linked</span>
          <span v-else style="color: #ff4c4c"><icon-base width="1em" height="1em" viewBox="0 0 25 25"><icon-un-link /></icon-base> Bank Account Not Yet Linked</span>
        </p>
        <p class="PaB-ach-text">
          <input v-model="pay_type" type="radio" name="pay_type" id="payment_cash" value="cash">
          <label for="payment_cash"> Pay with an alternative form of payment<br/><span style="font-size: 8px; margin-left: 18px">(Cash or POSaBIT Debit/Credit at participating locations)</span></label>
        </p>
      </form>
      <div class="PaB-button-group">

        <app-button type="alternative" :block="true" @click.native="posabitLogin" :disabled="!isPaymentPosabit">
          <template v-slot:after>
            <span v-if="!hasPosabitAccount">LOGIN TO <icon-base width="5em" height="1em" viewBox="0 0 302 66"><icon-posabit /></icon-base></span>
            <span v-else>MANAGE MY <icon-base width="5em" height="1em" viewBox="0 0 302 66"><icon-posabit /></icon-base> ACH ACCOUNT</span>
          </template>
        </app-button>
        <app-button type="extra" :block="true" label="Learn more about ach payments" @click.native="learnMore"/>
      </div>

    </template>

    <template slot="actions">
      <order-summary :items="cart.order_items_attributes"></order-summary>
      <p>
        <icon-base width="1em" height="1em">
          <icon-exclamation-circle />
        </icon-base> Legal limitations for maximum amount of product(s) apply.
      </p>
      <p>
        <icon-base width="1em" height="1em">
          <icon-exclamation-circle />
        </icon-base> Member discounts will be applied in-store!
      </p>
      <div class="PaB-button-group">
        <app-button type="primary" :block="true" label="Place My Order" @click.native="setPayment"
          :disabled="!isValidPayment"></app-button>
      </div>
    </template>
  </layout-checkout>
</template>

<style lang="scss" scoped>
.posabit-widget h3 {
  margin-top: 1em;
}

.PaB-form-input-check {
  position: relative;

  .PaB-error {
    margin-left: 20px;
    position: absolute;
    bottom: auto;
    top: -1em;
  }
}

.PaB-ach-text
{
  color: black;
  font-weight: bold;
  font-size: 14px;
}

.PaB-order-type {
  margin-right: 12px;
  flex: 1 1 200px;
  position: relative;
  select {
    background-image: none;
    display: block;
    width: 100%;
    appearance: none;
    min-height: 44px;
    height: 100%;
    border-radius: 0;
    line-height: 1;
    padding: 10px;
    margin: 0;
    background-color: #fff;
    font-size: inherit;
  }
  svg {
    position: absolute;
    top: 10px;
    right: 10px;
    pointer-events: none;
  }
}

.PaB-error {
  color: #d21313;
  position: absolute;
  bottom: 12px;
  font-size: 12px;
  margin: 0;
}

.posabit-info-banner {
  font-size: 14px;
  border: 2px solid #8ac440;
  padding: 5px;
}

</style>

<script>
import LayoutCheckout from '@/components/LayoutCheckout'
import OrderSummary from '@/components/OrderSummary'
import AppButton from '@/components/AppButton'
import Checkbox from '@/components/Checkbox'
import InputField from '@/components/InputField'
import SelectField from '@/components/SelectField'
import IconBase from '@/components/IconBase'
import IconExclamationCircle from '@/components/icons/IconExclamationCircle'
import IconAngleLeft from '@/components/icons/IconAngleLeft'
import PosabitAPI from '@/services/posabit-payments.service'
import IconLink from '@/components/icons/IconLink'
import IconUnLink from '@/components/icons/IconUnLink'
import IconPosabit from '@/components/icons/IconPosabit'
import Cookies from 'js-cookie'

export default {
  components: {
    LayoutCheckout,
    OrderSummary,
    AppButton,
    Checkbox,
    InputField,
    SelectField,
    IconBase,
    IconExclamationCircle,
    IconAngleLeft,
    IconLink,
    IconUnLink,
    IconPosabit
  },
  data () {
    return {
      pay_type: '',
      hasPosabitAccount: false,
      achEnabled: false,
      errors: {}
    }
  },
  computed: {
    cart () {
      return this.$store.state.cart
    },
    isValidPayment () {
      return this.pay_type === 'posabit' ? this.achEnabled : this.pay_type === 'cash'
    },
    isPaymentPosabit () {
      return this.pay_type === 'posabit'
    },
    venueInfo () {
      return this.$store.state.venue.info
    }
  },
  created () {
    // Back to cart if no items
    if (this.cart.order_items_attributes.length === 0) {
      this.backToCart()
    }
    const trackProducts = this.cart.order_items_attributes.map(product => {
      const parentProduct = this.$store.getters['products/findProduct'](product.product_parent_id)
      return {
        'id': product.product_id,
        'name': product.product_name,
        'brand': product.product_brand,
        'category': parentProduct.category,
        'price': product.price,
        'quantity': product.quantity
      }
    })
    this.eventTracking.checkout(trackProducts)
    this.eventTracking.sendPageview(this.$router.currentRoute.fullPath)
    if (!this.newTelephone()) {
      this.posabitUpdate()
    }
  },
  methods: {
    validatePayment () {
      this.errors = {}
    },
    setPayment (e) {
      if (e) { e.preventDefault() }
      this.validatePayment()

      this.$store.dispatch('cart/setPaymentMethod', this.pay_type === 'posabit' ? 'ACH' : 'Cash')
      this.$store.dispatch('cart/placeOrder')

      Cookies.set('phone', this.cart.telephone)

      const orderRoute = this.$router.currentRoute.fullPath.replace(/payment/, 'order')
      this.$router.push(orderRoute)
    },
    posabitUpdate () {
      PosabitAPI.get()
        .then(response => {
          this.hasPosabitAccount = response.data.Success
          this.achEnabled = response.data.Ach
          if (response.data.Success) {
            this.pay_type = response.data.Ach ? 'posabit' : 'cash'
          }
        })
        .catch(err => {
          console.warn(err)
        })
    },
    newTelephone () {
      var phone = Cookies.get('phone')
      if (phone === undefined) return true
      return phone !== this.cart.telephone
    },
    posabitLogin () {
      const POSABIT_ENDPOINT = process.env.VUE_APP_PAYMENT_ENDPOINT
      var left = (screen.width / 2) - (600 / 2)
      var top = (screen.height / 2) - (800 / 2)
      var url = POSABIT_ENDPOINT + (this.hasPosabitAccount ? 'ach' : 'sign_up')
      var posabitW = window.open(url, 'posabitPay', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no,width=600,height=800,left=' + left + ',top=' + top)
      if (window.focus) posabitW.focus()
    },
    learnMore () {
      var left = (screen.width / 2) - (600 / 2)
      var top = (screen.height / 2) - (800 / 2)
      var url = 'https://posabit.com/ach'
      var posabitW = window.open(url, 'posabitPay', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no,width=600,height=800,left=' + left + ',top=' + top)
      if (window.focus) posabitW.focus()
    },
    backToCart (e) {
      if (e) {
        e.preventDefault()
      }
      const currentRoute = this.$router.currentRoute.fullPath
      const routeParts = currentRoute.split('/payment')
      if (!routeParts[0]) {
        this.$router.push('/')
      } else {
        this.$router.push(`${routeParts[0]}`)
      }
    },
    onMessage (e) {
      if (e.data === 'posabit-complete') {
        this.posabitUpdate()
      }
    }
  },
  mounted: function () {
    window.addEventListener('message', this.onMessage)
  },
  beforeDestroy: function () {
    window.removeEventListener('message', this.onMessage)
  }
}
</script>
